import React from 'react';
import './App.css';
import TeamShowcase from './TeamShowcase'; // Importe ta nouvelle page

// Si tu veux remettre l'app de tâches plus tard, on garde les imports ici :
// import { useState, useEffect } from 'react';
// import { supabase } from './supabaseClient';
// import Auth from './Auth';
// import Home from './Home';

function App() {
  // --- MODE HACKATHON / PORTFOLIO ---
  // Pour l'instant, on affiche juste la vitrine de l'équipe à tout le monde.
  return (
    <div>
      <TeamShowcase />
    </div>
  );

  /* --- ANCIEN CODE (Gestion des Tâches) ---
  Garde ce code en commentaire pour le réactiver après le Hackathon !
  
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    })

    return () => subscription.unsubscribe();
  }, [])

  return (
    <div className="App">
      {!session ? <Auth /> : <Home session={session} />}
    </div>
  );
  */
}

export default App;